<template>
	<div class="TestQuestionManagement">
		<div class="body">
			<div>
				<div class="title-box">
					<span class="title">{{$t('QuesLibrary.ProblemList')}}</span>
					<span class="num">{{$t('QuesLibrary.NumberOfRecords')}}: {{ myTotal }}</span>
					<span :title="$t('QuesLibrary.Refresh')" @click="myRefresh" class="el-icon-refresh-right"></span>
				</div>
				<div class="operation">
					<el-form :inline="true" :model="myFormItem" class="demo-form-inline">
						<el-form-item>
							<el-select clearable size="small" v-model="myFormItem.collection" :placeholder="$t('QuesLibrary.MultipleChoiceBank')">
								<el-option-group v-for="group in bankOptions" :key="group.label" :label="group.label">
									<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-option-group>
							</el-select>
						</el-form-item>
						<el-form-item><el-input size="small" v-model="bankName" :placeholder="$t('QuesLibrary.EnterQuestionName')"></el-input></el-form-item>
						<el-form-item><el-input size="small" v-model="banklabelname" :placeholder="$t('QuesLibrary.EnterQuestionnaireLabel')"></el-input></el-form-item>
						<!-- <el-form-item>
							<el-select size="small" v-model="myFormItem.quesType" placeholder="请选择题型">
								<el-option v-for="item in quesTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item> -->

						<el-form-item>
							<el-button size="small" @click="myRefresh">{{$t('QuesLibrary.Resetting')}}</el-button>
							<el-button size="small" type="primary" @click="onMySerach">{{$t('QuesLibrary.Query')}}</el-button>
						</el-form-item>
					</el-form>
					<div>
						<el-popconfirm class="popconfirm" :title="$t('QuesLibrary.ConfirmDeletionSelectedIssues')" @confirm="onDelMyLists">
							<el-button slot="reference" size="small" type="danger">{{$t('QuesLibrary.Delete')}}</el-button>
						</el-popconfirm>
					</div>
				</div>
				<el-table
					v-loading="myTableLoading"
					ref="multipleMYTable"
					:data="myTableData"
					tooltip-effect="dark"
					style="width: 100%"
					@selection-change="myHandleSelectionChange"
				>
					<el-table-column align="center" type="selection" width="55"></el-table-column>

					<el-table-column align="center" :label="$t('QuesLibrary.IssueNames')" width="200">
						<template slot-scope="scope">
							<span v-html="scope.row.quesName"></span>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="name" :label="$t('QuesLibrary.AffiliatedQuestionBank')"></el-table-column>

					<!-- <el-table-column align="center" prop="typeName" label="题型"></el-table-column> -->

					<el-table-column align="center" :label="$t('QuesLibrary.QuestionnaireLabel')">
						<template slot-scope="scope">
							{{ queryLabelName(scope.row.quesJson) }}
						</template>
					</el-table-column>

					<el-table-column align="center" prop="address" width="300" :label="$t('QuesLibrary.Operate')">
						<template slot-scope="scope">
							<el-popover style="margin-right: 10px;" :append-to-body="false" placement="left" width="800" trigger="click">
								<ExamQuesTemplate v-if="paper.questionsList" :istestPreview="true" ref="examQuesTemplate" :paper="paper"></ExamQuesTemplate>
                        		<el-link slot="reference" @click="myPreview(scope.row)"  type="primary" :underline="false">{{$t('QuesLibrary.Preview')}}</el-link>
							</el-popover>
							<el-link @click="myEdit(scope.row)" type="primary" :underline="false">{{$t('QuesLibrary.Edit')}}</el-link>
							<el-popconfirm class="popconfirm" :title="$t('QuesLibrary.AreYouSureToDeleteTheIssue')" @confirm="myDelete(scope.row)">
								<el-link slot="reference" type="primary" :underline="false">{{$t('QuesLibrary.Delete')}}</el-link>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-box">
					<el-pagination background layout="prev, pager, next" :page-size="myPageSize" @current-change="myCurrentChange" :total="myTotal"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ExamQuesTemplate from '@/page/myQuestionnaire/components/testPaperDesign/index.vue';
import Paper from '@/components/examQuesTemplate/js/Paper.js';
import { mapState } from 'vuex';
export default {
	name: 'TestQuestionManagement',
	components: {
		ExamQuesTemplate
	},
	data() {
		return {
			bankName: '',
			banklabelname: '',
			paper: {},
			activeIndex: '1',
			myFormItem: {
				collection: '',
				quesType: '',
				difficulty: ''
			},
			myTableData: [],
			myTotal: 0,
			myPageSize: 10,
			myPageIndex: 1,
			myMultipleSelection: [],
			myTableLoading: false,
			// 题库
			bankOptions: [
				{
					label: this.$t('QuesLibrary.SelfBuiltQuestionBank'),
					options: []
				},
				{
					label: this.$t('QuesLibrary.BankSoalanSistem'),
					options: []
				}
			],
			RBFormItem: {
				collection: '',
				quesType: '',
				difficulty: ''
			},
			RBTableData: [],
			RBTotal: 0,
			RBPageSize: 10,
			RBPageIndex: 1,
			RBMultipleSelection: [],
			RBTableLoading: false,
			DDTableData: [],
			DDTotal: 0,
			DDPageSize: 10,
			DDPageIndex: 1,
			DDMultipleSelection: [],
			DDTableLoading: false,
			dialogThreshold: false,
			difficultyValue: [
				{
					value: 0.1,
					label: '0-10%'
				},
				{
					value: 0.2,
					label: '10%-20%'
				},
				{
					value: 0.3,
					label: '21%-30%'
				},
				{
					value: 0.4,
					label: '31%-40%'
				},
				{
					value: 0.5,
					label: '41%-50%'
				},
				{
					value: 0.6,
					label: '51%-60%'
				},
				{
					value: 0.7,
					label: '61%-70%'
				},
				{
					value: 0.8,
					label: '71%-80%'
				},
				{
					value: 0.9,
					label: '81%-90%'
				},
				{
					value: 1,
					label: '91%-100%'
				}
			],
			formThresholdUNK: {
				level1: 0.2,
				level2: 0.4,
				level3: 0.6,
				level4: 0.8,
				level5: 1
			},
			DDlist: [
				{
					value: this.$t('QuesLibrary.Easy'),
					label: 'level1'
				},
				{
					value: this.$t('QuesLibrary.Easier'),
					label: 'level2'
				},
				{
					value: this.$t('QuesLibrary.Middle'),
					label: 'level3'
				},
				{
					value: this.$t('QuesLibrary.RelativelyDifficult'),
					label: 'level4'
				},
				{
					value: this.$t('QuesLibrary.Difficult'),
					label: 'level5'
				}
			],
			formThresholdKNWN: {
				up: 0.5,
				down: 0.5
			},
			difficultyValueKNWN1: [
				{
					value: 0.1,
					label: '>10%'
				},
				{
					value: 0.2,
					label: '>20%'
				},
				{
					value: 0.3,
					label: '>30%'
				},
				{
					value: 0.4,
					label: '>40%'
				},
				{
					value: 0.5,
					label: '>50%'
				},
				{
					value: 0.6,
					label: '>60%'
				},
				{
					value: 0.7,
					label: '>70%'
				},
				{
					value: 0.8,
					label: '>80%'
				},
				{
					value: 0.9,
					label: '>90%'
				},
				{
					value: 1,
					label: '>100%'
				}
			],
			difficultyValueKNWN2: [
				{
					value: 0.1,
					label: '<10%'
				},
				{
					value: 0.2,
					label: '<20%'
				},
				{
					value: 0.3,
					label: '<30%'
				},
				{
					value: 0.4,
					label: '<40%'
				},
				{
					value: 0.5,
					label: '<50%'
				},
				{
					value: 0.6,
					label: '<60%'
				},
				{
					value: 0.7,
					label: '<70%'
				},
				{
					value: 0.8,
					label: '<80%'
				},
				{
					value: 0.9,
					label: '<90%'
				},
				{
					value: 1,
					label: '<100%'
				}
			],
			thresholdId: ''
		};
	},
	computed: {
		...mapState(['examQuesTypeArr']),
		quesTypeList() {
			let data = [
				{
					value: '',
					label: this.$t('QuesLibrary.NoLimit')
				}
			];
			data = [...data, ...this.examQuesTypeArr];
			return data;
		}
	},
	created() {
		this.handleSelect('1');
		this.getBankOptions();
	},
	methods: {
		queryLabelName(json) {
			let labelName = '';
			labelName = JSON.parse(json);
			if (labelName.quesLabelName != '' && labelName.quesLabelName) {
				return labelName.quesLabelName.toString();
			} else {
				return ' ';
			}
		},
		ascendingChange(e) {
			console.log(e);
			this.difficultyValueKNWN2.forEach(info => {
				if (info.value == e) {
					this.formThresholdKNWN.down = info.value;
				}
			});
		},
		descendingChange(e) {
			this.difficultyValueKNWN1.forEach(info => {
				if (info.value.indexOf(e) !== -1) {
					this.formThresholdKNWN.up = info.value;
				}
			});
		},
		toSetThreshold() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankGetDifficultyConf}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.formThresholdUNK = {
							level1: res.resultBody.unknownConf1,
							level2: res.resultBody.unknownConf2,
							level3: res.resultBody.unknownConf3,
							level4: res.resultBody.unknownConf4,
							level5: res.resultBody.unknownConf5
						};
						that.thresholdId = res.resultBody.id;
						that.formThresholdKNWN = {
							up: res.resultBody.addConf,
							down: res.resultBody.addConf
						};
					}
				}
			};
			this.$util.request(params);
			this.dialogThreshold = true;
		},
		getBankOptions() {
			this.getBankApi(0);
			this.getBankApi(1);
		},
		getBankApi(isSystem) {
			let that = this;
			let data = this.$qs.stringify({
				isSystem: isSystem, // 0自建题库 1系统题库
				pageIndex: 1,
				pageSize: 10000,
				bankType: 1
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						if (isSystem == 0) {
							res.resultBody.datas.forEach(info => {
								that.bankOptions[0].options.push({
									label: info.name,
									value: info.id
								});
							});
						} else {
							res.resultBody.datas.forEach(info => {
								that.bankOptions[1].options.push({
									label: info.name,
									value: info.id
								});
							});
						}
					} else {
						that.bankOptions = [
							{
								label: that.$t('QuesLibrary.SelfBuiltQuestionBank'),
								options: []
							},
							{
								label: that.$t('QuesLibrary.BankSoalanSistem'),
								options: []
							}
						];
					}
				}
			};
			this.$util.request(params);
		},
		handleSelect(key) {
			this.activeIndex = key;
			this.getData(false);
		},
		getData(state) {
			this.myTableLoading = true;
			this.RBTableLoading = true;
			let that = this;
			let data = this.$qs.stringify({
				pageIndex: this.myPageIndex,
				pageSize: this.myPageSize,
				bankIds: this.myFormItem.collection,
				name: this.bankName,
				labelname: this.banklabelname,
				isDel: state ? 1 : 0, // 是否删除
				isAdmin: 1 // 是否管理员
			});
			// examBankQuesList  quesBank
			let params = {
				that: this,
				url: `${this.$config.service.quesBank}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					that.myTableLoading = false;
					that.RBTableLoading = false;
					if (res.code == '0') {
						if (state) {
							that.RBTableData = res.resultBody.datas;
							that.RBTotal = res.resultBody.total;
							that.RBTableData.forEach(info => {
								that.$set(info, 'typeName', that.$t('QuesLibrary.Radio'));
								switch (info.type) {
									case '100':
										info.typeName = '单选';
										break;
									case '101':
										info.typeName = '多选';
										break;
									case '102':
										info.typeName = '判断';
										break;
									case '204':
										info.typeName = '填空';
										break;
									case '206':
										info.typeName = '简答';
										break;
									case '207':
										info.typeName = '多项填空';
										break;
									case '208':
										info.typeName = '横向填空';
										break;
									case '403':
										info.typeName = '上传文件';
										break;
									case '209':
										info.typeName = '绘图';
										break;
									case '401':
										info.typeName = '段落标题';
										break;
								}
							});
						} else {
							that.myTableData = res.resultBody.datas;
							that.myTotal = res.resultBody.total;
							that.myTableData.forEach(info => {
								that.$set(info, 'typeName', '单选');
								switch (info.type) {
									case '100':
										info.typeName = '单选';
										break;
									case '101':
										info.typeName = '多选';
										break;
									case '102':
										info.typeName = '判断';
										break;
									case '204':
										info.typeName = '填空';
										break;
									case '206':
										info.typeName = '简答';
										break;
									case '207':
										info.typeName = '多项填空';
										break;
									case '208':
										info.typeName = '横向填空';
										break;
									case '403':
										info.typeName = '上传文件';
										break;
									case '209':
										info.typeName = '绘图';
										break;
									case '401':
										info.typeName = '段落标题';
										break;
								}
							});
							console.log(that.myTableData);
						}
					} else {
						that.myTableData = [];
						that.myTotal = 0;
						that.RBTableData = [];
						that.RBTotal = 0;
					}
				}
			};
			this.$util.request(params);
		},
		getcollData() {
			this.collTableLoading = true;
			let that = this;
			let data = this.$qs.stringify({
				pageIndex: this.DDPageIndex,
				pageSize: this.DDPageSize,
                pageSize: 1,
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankInferenceList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					that.collTableLoading = false;
					if (res.code == '0') {
						that.DDTableData = res.resultBody.datas;
						that.DDTotal = res.resultBody.total;
					} else {
						that.DDTableData = [];
						that.DDTotal = 0;
					}
				}
			};
			this.$util.request(params);
		},
		myCurrentChange(e) {
			this.myPageIndex = e;
			// 刷新列表
			this.getData(false);
		},
		myDelete(item) {
			let arr = [
				{
					bankId: item.bid,
					id: item.id
				}
			];
			this.saveMyDelApi(arr);
		},
		onDelMyLists() {
			let arr = [];
			if (this.myMultipleSelection.length == 0) {
				this.$message({
					message: this.$t('QuesLibrary.SelectTheQuestionToDelete'),
					type: 'warning'
				});
				return;
			}
			this.myMultipleSelection.forEach(info => {
				arr.push({
					bankId: info.bid,
					id: info.id
				});
			});
			this.saveMyDelApi(arr);
		},
		saveMyDelApi(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankDelQues}`,
				method: 'POST',
				data: ids,
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.getData(false);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		myRefresh() {
			this.onMyReset();
			this.getData(false);
		},
		onMyReset() {
			this.myPageIndex = 1;
			this.bankName = '';
			this.banklabelname = '';
			this.myFormItem.collection = '';
		},
		onMySerach() {
			this.myPageIndex = 1;
			this.getData(false);
		},
		myPreview(item) {
			// 我的问题预览
			this.paper = new Paper(); // 初始化paper
			this.paper.questionsList.push(JSON.parse(item.quesJson));
		},
		DDInfo(item) {
			// 难度反推问题预览
			this.paper = new Paper(); // 初始化paper
			this.paper.questionsList.push(JSON.parse(item.quesJson));
		},
		myEdit(item) {
			console.log(item);
			// // 打开问题设计页面
			// this.$router.push({
			// 	path: '/editQuestion',
			// 	query: {
			// 		id: item.id,
			// 		bid: item.bid,
			// 		isTestEdit: true
			// 	}
			// });
// ?bankId=828214adf0b0cb1dccc06e6e11c56bac&title=eqwe&depict=qe&isEdit=true&back=5
			// 编辑问题
			this.$router.push({
				path: '/editQuestionWJ',
				query: {
					bankId: item.bid,
					questionsId: item.id,
					title: item.name,
					depict: item.remark,
					isEdit: true,
					back: 8
				}
			});
		},
		myHandleSelectionChange(val) {
			console.log(val);
			this.myMultipleSelection = val;
		},
		RBRefresh() {
			this.onRBReset();
			this.getData(true);
		},
		onRBReset() {
			this.RBPageIndex = 1;
			this.RBFormItem = {
				collection: '',
				quesType: '',
				difficulty: ''
			};
		},
		onRBSerach() {
			this.RBPageIndex = 1;
			this.getData(true);
		},
		RBHandleSelectionChange(val) {
			console.log(val);
			this.RBMultipleSelection = val;
		},
		RBRecovery(item) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankRecycleBinRenew}?id=${item.id}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.getData(true);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		RBDelete(item) {
			let arr = [item.id];
			this.saveRBDelApi(arr);
		},
		onDelRBLists() {
			let arr = [];
			if (this.RBMultipleSelection.length == 0) {
				this.$message({
					message: this.$t('QuesLibrary.SelectTheQuestionToDelete'),
					type: 'warning'
				});
				return;
			}
			this.RBMultipleSelection.forEach(info => {
				arr.push(info.id);
			});
			this.saveRBDelApi(arr);
		},
		saveRBDelApi(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankRecycleBinDel}?ids=${ids}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.getData(true);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		RBCurrentChange(e) {
			this.RBPageIndex = e;
			this.getData(true);
		},
		DDRefresh() {
			this.DDPageIndex = 1;
			this.getcollData();
		},
		DDHandleSelectionChange(val) {
			console.log(val);
			this.DDMultipleSelection = val;
		},
		DDCurrentChange(e) {
			this.DDPageIndex = e;
			this.getcollData();
		},
		DDBackstepping(info) {
			let arr = [
				{
					bid: info.bid,
					difficulty: info.difficulty,
					newDifficulty: info.newDifficulty,
					qid: info.id
				}
			];
			this.saveBacksteppingApi(arr);
		},
		batchBackstepping() {
			// 批量反推
			let arr = [];
			this.DDMultipleSelection.forEach(info => {
				arr.push({
					bid: info.bid,
					difficulty: info.difficulty,
					newDifficulty: info.newDifficulty,
					qid: info.id
				});
			});
			this.saveBacksteppingApi(arr);
		},
		saveBacksteppingApi(arr) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankInference}`,
				method: 'POST',
				data: arr,
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.getcollData();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleCloseThreshold() {
			// 关闭前清除数据
			this.dialogThreshold = false;
		},
		cancelThreshold() {
			this.dialogThreshold = false;
		},
		setThreshold() {
			// 确定

			let that = this;
			let data = {
				addConf: this.formThresholdKNWN.up,
				id: this.thresholdId,
				unknownConf1: this.formThresholdUNK.level1,
				unknownConf2: this.formThresholdUNK.level2,
				unknownConf3: this.formThresholdUNK.level3,
				unknownConf4: this.formThresholdUNK.level4,
				unknownConf5: this.formThresholdUNK.level5
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddDifficultyConf}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.dialogThreshold = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
			console.log(this.formThresholdUNK);
		}
	}
};
</script>

<style lang="scss" scoped>
.TestQuestionManagement {
	/deep/.el-menu {
		position: static;
	}
	.el-menu-demo {
		padding-left: 20px;
		border-bottom: 1px solid #bbb;
	}
	/deep/.el-menu--horizontal > .el-menu-item.is-active,
	/deep/.el-menu--horizontal > .el-menu-item {
		border-bottom: none !important;
	}
	/deep/.el-menu-item {
		font-size: 16px;
	}
	.el-icon-refresh-right {
		cursor: pointer;
	}
	.body {
		padding: 0 40px;
		.title-box {
			line-height: 42px;
			span {
				font-size: 12px;
				color: #a7a6a6;
			}
			.title {
				font-size: 14px;
				color: #696868;
			}
			span + span {
				margin-left: 10px;
			}
		}
		.operation {
			display: flex;
			justify-content: space-between;
		}
		.operation-DD {
			height: 62px;
			display: flex;
			justify-content: flex-end;
		}
		.page-box {
			margin-top: 20px;
			text-align: center;
		}
		.popconfirm {
			margin-left: 10px;
		}
	}
	.title-threshold {
		margin-bottom: 20px;
	}
	.dialogThreshold {
		/deep/.el-dialog {
			width: 650px;
		}
		.tip {
			display: inline-block;
			margin-left: 5px;
			font-size: 12px;
			color: #848383;
		}
	}
}
</style>
